import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'PublicWhatsAppReplyPage.title',
    defaultMessage: 'Reply to WhatsApp',
  },
  subtitle: {
    id: 'PublicWhatsAppReplyPage.subtitle',
    defaultMessage: 'Send a message to continue the conversation',
  },
  conversationNotFound: {
    id: 'PublicWhatsAppReplyPage.conversationNotFound',
    defaultMessage: 'Conversation not found or has expired',
  },
  send: {
    id: 'PublicWhatsAppReplyPage.send',
    defaultMessage: 'Send',
  },
  sending: {
    id: 'PublicWhatsAppReplyPage.sending',
    defaultMessage: 'Sending...',
  },
  messageSent: {
    id: 'PublicWhatsAppReplyPage.messageSent',
    defaultMessage: 'Message sent successfully!',
  },
  messageError: {
    id: 'PublicWhatsAppReplyPage.messageError',
    defaultMessage: 'Failed to send message. Please try again.',
  },
})
